<template>
    <el-input :value="value" readonly="readonly" ></el-input>    
</template>

<script>
export default {
    name:'l-tenantcompanyid',
    props: {
        value:{},
    },
    watch: {
        value:{
            handler(newVal){
                if(this.$validatenull(newVal) && this.loginInfo){
                    //this.lr_loadUsers && this.lr_loadUsers(this.loginInfo.f_UserId)
                    this.$emit('input',this.loginInfo.tenantCompanyId)
                }
            },
            immediate: true
        }
    },
    data () {
        return {
        }
    }
}
</script>